/* eslint-disable import/prefer-default-export */
export enum FAQSearchParamKey {
  Filter = 'f',
  Product = 'p',
  Question = 'q',
}
